import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';

export const ContainerBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    width: '50%',
    marginBottom: spacing(1),
    [breakpoints.up('sm')]: {
      width: '25%',
    },
    [breakpoints.up('md')]: {
      width: 'auto',
      marginBottom: 0,
    },
  },
}))((props) => <Box {...props} />);

export const Label = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props) => <FsBodySmall component="h5" {...props} />);

export const Value = withStyles({})((props) => (
  <FsBodySmallBold component="strong" {...props} />
));
